"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftArrayRight = void 0;
var tslib_1 = require("tslib");
/**
 * Shift array once to the right
 *
 * @param array - some array
 * @internal
 */
function shiftArrayRight(array) {
    if (!(array === null || array === void 0 ? void 0 : array.length)) {
        return array;
    }
    var _a = tslib_1.__spreadArrays(array).reverse(), last = _a[0], res = _a.slice(1);
    return tslib_1.__spreadArrays([last], res.reverse());
}
exports.shiftArrayRight = shiftArrayRight;
//# sourceMappingURL=arrayUtils.js.map